module.exports = __webpack_public_path__ + "static/media/img_gear.31ec34ea.webp";